import { useRef, useEffect } from 'react';

import icon_close from '../assets/icon_close.svg';

const Modal = ({
  modalTitle,
  modalImage,
  clearModal,
  renderModalContent,
  updateSettings,
  showMobile,
  shouldDisable,
}) => {
  const outsideModalRef = useRef(null);
  let headerImage = false;

  useEffect(() => {
    window.addEventListener('click', hideModal);

    return () => {
      window.removeEventListener('click', hideModal);
    };
  }, []);

  function hideModal(e) {
    if (e.target === outsideModalRef.current) {
      clearModal();
    }
  }

  const saveUpdates = () => {
    updateSettings();
    clearModal();
  };

  if (modalImage) {
    headerImage = (
      <div className="modal-image">
        <img src={modalImage} alt="modal icon" width="18" height="18" />
      </div>
    );
  }

  return (
    <div className="modal-overlay" ref={outsideModalRef}>
      <div className={showMobile ? 'modal' : 'modal desktop'}>
        <div className={'modal-header-container' + (modalImage ? ' has-image' : '')}>
          <div className="modal-title">
            {headerImage}
            {modalTitle}
          </div>

          <button className="close-button" onClick={() => clearModal()}>
            <img src={icon_close} alt="X icon to close modal" width="20" height="20" />
          </button>
        </div>

        <div className="modal-content">{renderModalContent}</div>
        <div className="btn-container modal-footer">
          <input type="button" className="modal-btn" onClick={clearModal} value="Cancel" />
          <input
            type="button"
            className="modal-btn cta"
            onClick={saveUpdates}
            disabled={shouldDisable}
            value="Confirm"
          />
        </div>
      </div>
    </div>
  );
};

export default Modal;
